/**
 * Reads the editable grid's row slice out of the page store.
 *
 *   gridRows.store.ts  ── types · pure helpers · createGridRowsSlice ──┐
 *                                                                     │ slice
 *   StoreStateProvider ── withLenses({ editableGridInternal: … }) ◄────┘
 *          │
 *          └─ useEditableGridRows(selector)  ── every editable grid + cell
 *
 * Lives here, not in `gridRows.store.ts`, so the store file exports only state
 * and pure functions: a `.store` file that also built a React hook was the one
 * misnamed export in the grid layer, and importing it dragged the whole store
 * runtime (and a module cycle through viewConfig.store) into anything that
 * only wanted a type.
 */
import type { GridRowActions, GridRowState } from 'src/lib/gridRows.store';
import { EDITABLE_GRID_SLICE } from 'src/lib/gridRows.store';
import { createUseStoreState } from 'src/utils/createUseStoreState';

export const useEditableGridRows = createUseStoreState<GridRowState & GridRowActions>(EDITABLE_GRID_SLICE);
